import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FinishProfileItem} from 'src/app/product-details/interface/finish-profile-item-list';
import {CurrencyResolverService} from "../../../../currency-resolver.service";
import {ApCurrency} from "../../../../pipe/enum/ap-currency";

@Component({
  selector: 'fb-more-finish-info',
  templateUrl: './more-finish-info.component.html',
  styleUrls: ['./more-finish-info.component.scss']
})
export class MoreFinishInfoComponent implements OnInit {

	public selectedCurrency: ApCurrency = ApCurrency.USD;
	constructor(
		private _currencyResolver: CurrencyResolverService
	){

	}
	@Input() chooseFinishMorePopupdata: FinishProfileItem = {} as FinishProfileItem;
	@Output() closeOption = new EventEmitter();

	public closeInfo(): void {
		this.closeOption.emit();
	}

	ngOnInit() {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
	}
}
